// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"8bbe3b99","184":"d35fad4c","289":"9d14af17","454":"99e82396","609":"9acccd9a","896":"e8bd4bec","948":"af04d22c"}[chunkId] + ".chunk.js";
};